import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import { toast } from "react-toastify";

const Login = () => {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success("Login successful!");
      navigate("/");
    } catch (error) {
      toast.error("Login failed. Please check your email and password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen w-screen bg-black flex items-center justify-center">
      <div className="flex max-md:flex-col h-[400px] max-md:h-fit w-[700px] bg-white border shadow-lg rounded-lg overflow-hidden">
        <div
          className="flex-1 bg-cover bg-center bg-no-repeat p-12 flex flex-col gap-2 text-white"
          style={{
            backgroundImage:
              "linear-gradient(rgba(39, 11, 96, 0.5), rgba(39, 11, 96, 0.5)), url('https://www.euroschoolindia.com/wp-content/uploads/2023/07/importance-of-education.jpg')",
          }}
        >
          <h1 className="text-[50px] leading-none font-bold">TSL Admin</h1>
          <p>Tanzania Sign Language</p>
          {/* <span className="text-sm">Don't have an account?</span>
          <Link to="admin/register">
            <button className="w-1/2 py-2 bg-white text-[#120e63] font-bold cursor-pointer">
              Register
            </button>
          </Link> */}
        </div>
        <div className="flex-1 p-12 flex flex-col gap-4 justify-center">
          <h1 className="text-[#120e63] font-bold text-2xl">Login</h1>
          <form className="flex flex-col gap-3" onSubmit={handleLogin}>
            <label htmlFor="email" className="sr-only">
              Email
            </label>
            <input
              id="email"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
            />

            <label htmlFor="password" className="sr-only">
              Password
            </label>
            <input
              id="password"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-b border-gray-300 py-3 px-3 focus:outline-none"
            />

            <button
              type="submit"
              disabled={loading}
              className={`w-1/2 py-2 font-bold text-white cursor-pointer ${
                loading ? "bg-gray-400" : "bg-[#120e63]"
              }`}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;